<template>
  <v-app id="media-map">
    <component :is="this.$store.state.currentNav" v-bind:drawer="navDrawer" id="nav"></component>
    <router-view></router-view>
    <v-snackbar
      v-model="snackbar.active"
      :bottom="true"
      :right="true"
      :timeout=6000
      :color="snackbar.color"
    >
      {{ snackbar.content }}
      <v-btn
        dark
        text
        @click="snackbar.active = false"
      >
        {{ $t('base.close') }}
      </v-btn>
    </v-snackbar>
    <Login />
  </v-app>
</template>

<script>
  import Map from './views/Map'
  import Login from './components/Login'

  export default {
    components: {
      Map,
      Login
    },
    computed: {
      navDrawer: {
        get () {
          return this.$store.state.nav
        },
        set (val) {
          this.$store.commit('nav', val)
        }
      },
      snackbar: {
        get () {
          return this.$store.state.snackbar
        },
        set (val) {
          this.$store.commit('snackbar', val)
        }
      }
    },
    data: () => ({
    }),
    methods: {
    }
  }
</script>

<style>
  html { overflow-y: auto !important }
  .lightbox {
    box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 72px);
  }
  #nav {
    z-index: 1201;
  }

  .v-navigation-drawer {
    height: 100% !important;
  }
</style>